var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoPencil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1635 5.98157L8.75366 61.4893L14.6526 67.3987L70.0625 11.891L64.1635 5.98157Z",
    fill: "#FDC000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3414 4.79905L64.165 5.97754L70.064 11.8869L71.2404 10.7085L65.3414 4.79905Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6996 2.42991L66.5232 3.6084L72.4222 9.5178L73.5986 8.33931L67.6996 2.42991Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5265 3.61155L65.3501 4.79004L71.2491 10.6994L72.4255 9.52095L66.5265 3.61155Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8844 1.24241L67.708 2.4209L73.607 8.3303L74.7834 7.15181L68.8844 1.24241Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7791 7.19378C75.1721 6.80486 75.4847 6.34221 75.6992 5.83226C75.9137 5.3223 76.0258 4.77502 76.0291 4.22167C76.0324 3.66831 75.9269 3.11972 75.7186 2.60721C75.5103 2.09469 75.2033 1.6283 74.815 1.23466C74.4268 0.841015 73.965 0.527829 73.4559 0.312984C72.9469 0.0981377 72.4006 -0.0141612 71.8482 -0.0175014C71.2958 -0.0208415 70.7482 0.0848425 70.2366 0.293517C69.725 0.502191 69.2594 0.809768 68.8665 1.19869L74.7791 7.19378Z",
    fill: "#C07C00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75796 61.4859L0.846436 75.2866L14.6467 67.3851V65.4067H12.6838V63.4403H10.7089V61.4619L8.75796 61.4859Z",
    fill: "#C69C6D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79622 71.3415C4.44482 70.9928 4.00682 70.7444 3.5275 70.6221L0.846436 75.2862L5.51436 72.6124C5.39279 72.1321 5.14479 71.6931 4.79622 71.3415V71.3415Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/InfoPencil.1be46d2abd29a27320cfdb937734fc33.svg";